import { memo, useMemo } from 'react';

import { CopyText, Flex, Label } from '@/components/core';
import { ActionRunTest, HowToGuide, HttpUrl } from '@/components/flow';
import { useGetAppClientWithSecret } from '@/hooks';
import { useTriggerStore } from '@/store';
import { isNotConfiguredExport } from '@/utils';

export type ExportPowerAutomateConfigurationProps = object;

// eslint-disable-next-line no-empty-pattern
const IExportPowerAutomateConfiguration = ({}: ExportPowerAutomateConfigurationProps = {}) => {
  const action = useTriggerStore((state) => state.action);

  const { data: appClient } = useGetAppClientWithSecret();
  const clientCredentials = useMemo(
    () => (appClient?.clientSecret ? btoa(`${appClient.clientId}:${appClient.clientSecret}`) : undefined),
    [appClient]
  );

  const isConfigured = !isNotConfiguredExport(action);

  return (
    <Flex col className="gap-md p-md grow">
      <Flex variant="plain" col className="p-md gap-4 rounded-lg border-1 border-gray-100 bg-white shadow-xs">
        <HttpUrl isDisabled placeholder="URL will be automatically updated from Power Automate" />
        <Flex col className="gap-xs">
          <Label>Client Credentials</Label>
          <CopyText isSensitive value={clientCredentials} />
        </Flex>
      </Flex>

      {isConfigured && <ActionRunTest label="Test connection" />}

      <div className="grow" />

      <HowToGuide actionId={action?.actionId} />
    </Flex>
  );
};

export const ExportPowerAutomateConfiguration = memo(
  IExportPowerAutomateConfiguration
) as typeof IExportPowerAutomateConfiguration;
